import { useEffect, useState } from "react"

import { ProjectRef } from "@vertesia/common"
import { Check, ChevronsDownUp, ChevronsUpDown, Folder } from "lucide-react"

import { useUserSession } from "@session/UserSession"

import { Button } from "@ui/button"
import { Input } from "@ui/input"
import { Popover, PopoverContent, PopoverTrigger } from "@ui/popover"

export function ProjectSelection() {
    const { client, project, user, account, switchProject } = useUserSession()

    const [projects, setProjects] = useState<ProjectRef[]>([])

    const [open, setOpen] = useState(false)
    const [filterValue, setFilterValue] = useState("")

    const filteredOptions = projects?.filter((pro) => pro.name.toLowerCase().includes(filterValue.toLowerCase()) && pro.id !== project?.id)

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.stopPropagation()
        setFilterValue(e.target.value)
    }

    const handleInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        e.stopPropagation()
    }

    useEffect(() => {
        if (!client || !user) {
            return
        }

        client.projects.list(account?.id ? [account?.id] : undefined).then((projects) => {
            setProjects(projects)
        })
    }, [client, user, account])

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <div className="flex flex-row border gap-2 items-center justify-center cursor-pointer hover:bg-gray-200 rounded-md">
                    <div className="border-r">
                        <Folder className="p-1" />
                    </div>
                    <div className="w-full text-sm font-light text-left text-primary truncate">{project?.name}</div>
                    <div className="border-l">{open ? <ChevronsDownUp className="p-1 opacity-50" /> : <ChevronsUpDown className="p-1 opacity-50" />}</div>
                </div>
            </PopoverTrigger>
            <PopoverContent className="max-w-[300px] p-2 border shadow" align="start">
                {projects && projects.length > 5 && <Input placeholder="Search Projects..." value={filterValue} onChange={handleInputChange} onKeyDown={handleInputKeyDown} onClick={(e) => e.stopPropagation()} className="mb-2" />}
                <div className="flex flex-col gap-2 max-h-[200px] overflow-y-auto">
                    {project && (
                        <Button variant="ghost" className="text-xs text-left justify-between w-full bg-gray-100">
                            {project.name}
                            <Check />
                        </Button>
                    )}
                    {filteredOptions?.map((pro) => (
                        <Button key={pro.id} variant="ghost" className="text-xs text-left justify-between w-full" onClick={() => switchProject(pro.id)}>
                            <div className="truncate">{pro.name}</div>
                        </Button>
                    ))}
                </div>
            </PopoverContent>
        </Popover>
    )
}
